module.exports = function () {
  var faction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'allies';
  var html = "\n      <div class=\"reserves-overlay ".concat(faction, "\" id=\"reserves-overlay\">\n        <div class=\"units\"></div>\n        <div class=\"status\"></div>\n        <div class=\"controls\"></div>\n      </div>\n  ");
  return html;
};